import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { toRefs } from 'vue';
import { IonRow, IonCol, IonGrid } from '@ionic/vue';

import { IUnit } from '@/support/models/unit.interface';
import ListCard from '@/components/List/ListCard.vue';
import LockedCard from '@/components/Common/LockedCard.vue';

import { useProgress } from '@/composables/progress';
import { IProgress } from '@/support/interfaces/ui';


export default /*#__PURE__*/_defineComponent({
  __name: 'UnitList',
  props: {
    units: null,
    courseId: null
  },
  setup(__props: any) {

const props = __props as {
  units: IUnit[];
  courseId: number;
}

const { listOfChapters } = useProgress();



const { units, courseId } = toRefs(props);

const completedChapters = (unit: IUnit): number => {
  const chapterIds: number[] = unit.chapters.map((chapter) => chapter.id);

  return Object.values(listOfChapters(chapterIds)).filter(
    (chapter) => chapter.completed
  ).length;
};

const getProgress = (unit: IUnit): IProgress => {
  return {
    done: completedChapters(unit),
    count: unit.chapters.length,
  };
};

const readMoreChapters = (currentIndex: number): number => {
  let count = 0;

  for (let i = 0; i < currentIndex; i++) {
    count += units.value[i].chapters.length - completedChapters(units.value[i]);
  }

  return count;
};

const isComplete = (unit: IUnit): boolean => {
  if (unit.chapters.length === 0) {
    return false;
  }

  return unit.chapters.length - completedChapters(unit) === 0;
};

const isPreviousCompleted = (index: number): boolean => {
  if (index === 0) {
    return true;
  }

  const unit = units.value[index - 1];

  return isComplete(unit);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonGrid), null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(units), (unit, index) => {
        return (_openBlock(), _createBlock(_unref(IonRow), { key: index }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), null, {
              default: _withCtx(() => [
                (isPreviousCompleted(index))
                  ? (_openBlock(), _createBlock(ListCard, {
                      key: 0,
                      title: unit.name,
                      type: "Unit",
                      subtitle: "Subtitle for the unit",
                      number: index + 1,
                      "router-link": `/course/${_unref(courseId)}/unit/${unit.id}`,
                      progress: getProgress(unit)
                    }, null, 8, ["title", "number", "router-link", "progress"]))
                  : (_openBlock(), _createBlock(LockedCard, {
                      key: 1,
                      title: unit.name,
                      subtitle: `Read ${readMoreChapters(index)} more chapters to unlock`
                    }, null, 8, ["title", "subtitle"]))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})